<script>
import { required, integer, minValue, maxValue } from 'vuelidate/lib/validators'

export default {
  name: 'abs-thermo-specs',
  props: {
    value: { type: Object, default: () => {} }
  },

  data: vm => ({
    form: {
      specs: {
        date_delivery: null,
        foot_plate_width: null
      },
      reference: '',
      ...vm.value
    }
  }),
  validations: {
    form: {
      specs: {
        date_delivery: {
          required
        },
        foot_plate_width: {
          required
        }
      },
      reference: {
        required
      }
    }
  },
  computed: {
    FOOT_PLATES () {
      return [
        { value: null, text: ' - Select a Foot Plate Width -' },
        { value: 8, text: '8cm' },
        { value: 9, text: '9cm' },
        { value: 10, text: '10cm' },
        { value: 11, text: '11cm' },
        { value: 0, text: 'No Footplates Required' }
      ]
    }
  },
  methods: {
    validate () {
      if (!this.$v && !this.$v.form) return true
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('validated', { ...this.form })
        this.$emit('input', { ...this.form })
      }

      return !this.$v.form.$invalid
    },
    dateDisabled (ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()

      const isPast = date < new Date()

      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6 || isPast
    }
  }
}
</script>
<template>
  <b-row>
    <b-col cols="12">
      <g-form-error-wrapper :validations="$v.form.reference">
        <template v-slot="{ errors, invalid }">
          <g-text-input
            v-model="form.reference"
            :label="$t('Your Reference *')"
            :placeholder="$t('Your reference. i.e. po number, patient name')"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.reference.$touch()"
          >
          </g-text-input>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.date_delivery">
        <template v-slot="{ errors, invalid }">
          <g-date-input
            v-model="form.specs.date_delivery"
            :date-disabled-fn="dateDisabled"
            locale="en"
            :label="$t('Delivery Date of Plaster Cast')"
            :placeholder="$t('Date')"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:blur="$v.form.specs.date_delivery.$touch()"
            label-cols-sm="6"
            label-cols-lg="4"
            max-width="280px"
          ></g-date-input>
        </template>
      </g-form-error-wrapper>

      <g-form-error-wrapper :validations="$v.form.specs.foot_plate_width">
        <template v-slot="{ errors, invalid }">
          <g-select
            v-model.number="form.specs.foot_plate_width"
            :label="$t('Foot Plates')"
            :options="FOOT_PLATES"
            buttons
            button-variant="outline-primary"
            :error-messages="errors"
            :is-valid="!invalid"
            v-on:change="$v.form.specs.foot_plate_width.$touch()"
            label-cols-sm="6"
            label-cols-lg="4"
            max-width="200px"
          >
          </g-select>
        </template>
      </g-form-error-wrapper>

      <small class="text-muted"
        >* Please write the reference on the plaster cast along with your
        company name.</small
      >
    </b-col>
  </b-row>
</template>
